import { useEffect, useMemo } from 'react';
import JsonLd from './JsonLd';
import { orgSchema, websiteSchema } from '../content/schema';
import { seoApi } from '../services/api';

function setVerifyMeta(name, content) {
  document.head
    .querySelectorAll(`meta[name="${name}"][data-seo-verify="1"]`)
    .forEach((e) => e.remove());
  if (!content) return;
  const el = document.createElement('meta');
  el.setAttribute('name', name);
  el.setAttribute('content', content);
  el.setAttribute('data-seo-verify', '1');
  document.head.appendChild(el);
}

// Site-wide JSON-LD (Organization + WebSite/SearchAction) and the Search Console
// / Bing verification <meta> tags pasted by an admin. Rendered on every page.
export default function GlobalSeo() {
  const data = useMemo(() => [orgSchema(), websiteSchema()], []);

  useEffect(() => {
    let active = true;
    seoApi
      .getVerification()
      .then((r) => {
        if (!active) return;
        setVerifyMeta('google-site-verification', r.data && r.data.google);
        setVerifyMeta('msvalidate.01', r.data && r.data.bing);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return <JsonLd id="global" data={data} />;
}
